// Oral
export const RESET_APP = 'RESET_APP';

// Plase en blokke
export const INIT_PLASE = 'INIT_PLASE';
export const GET_PLASE = 'GET_PLASE';
export const SET_PLASE = 'SET_PLASE';
export const GET_PLASE_FAILED = 'GET_PLASE_FAILED';
export const KIES_PLAAS = 'KIES_PLAAS';
export const CENTER_PLAAS = 'CENTER_PLAAS';

export const INIT_ALLE_BLOKKE = 'INIT_ALLE_BLOKKE';
export const GET_ALLE_BLOKKE = 'GET_ALLE_BLOKKE';
export const SET_ALLE_BLOKKE = 'SET_ALLE_BLOKKE';
export const GET_ALLE_BLOKKE_FAILED = 'GET_ALLE_BLOKKE_FAILED';

export const INIT_BLOKKE = 'INIT_BLOKKE';
export const GET_BLOKKE = 'GET_BLOKKE';
export const SET_BLOKKE = 'SET_BLOKKE';
export const GET_BLOKKE_FAILED = 'GET_BLOKKE_FAILED';
export const KIES_BLOK = 'KIES_BLOK';

export const INIT_PLAAS = 'INIT_PLAAS';
export const GET_PLAAS = 'GET_PLAAS';
export const SET_PLAAS = 'SET_PLAAS';
export const GET_PLAAS_FAILED = 'GET_PLAAS_FAILED';

export const INIT_BLOK = 'INIT_BLOK';
export const GET_BLOK = 'GET_BLOK';
export const SET_BLOK = 'SET_BLOK';
export const GET_BLOK_FAILED = 'GET_BLOK_FAILED';

export const INIT_EENHEIDVERH = 'INIT_EENHEIDVERH';
export const GET_EENHEIDVERH = 'GET_EENHEIDVERH';
export const SET_EENHEIDVERH = 'SET_EENHEIDVERH';
export const GET_EENHEIDVERH_FAILED = 'GET_EENHEIDVERH_FAILED';

// UI
export const LEFTSIDEBAR_TOGGLE = 'LEFTSIDEBAR_TOGGLE';
export const PLUKTEIKENCHANGE_TOGGLE = 'PLUKTEIKENCHANGE_TOGGLE';
export const LAYERPOPOVER_TOGGLE = 'LAYERPOPOVER_TOGGLE';
export const PLAASGRENS_TOGGLE = 'PLAASGRENS_TOGGLE';
export const PLAASFILL_TOGGLE = 'PLAASFILL_TOGGLE';
export const PLAASNAAM_TOGGLE = 'PLAASNAAM_TOGGLE';
export const BLOKGRENS_TOGGLE = 'BLOKGRENS_TOGGLE';
export const BLOKFILL_TOGGLE = 'BLOKFILL_TOGGLE';
export const BLOKNAAM_TOGGLE = 'BLOKNAAM_TOGGLE';
export const EDITMODE_TOGGLE = 'EDITMODE_TOGGLE';
export const EERSTEPLUKDATUMCHANGE_TOGGLE = 'EERSTEPLUKDATUMCHANGE_TOGGLE';

// Map
export const SET_MAP = 'SET_MAP';
export const SEARCH_TOGGLE = 'SEARCH_TOGGLE';
export const ON_SEARCH_CHANGE = 'ON_SEARCH_CHANGE';
export const ON_PLACE_SELECT = 'ON_PLACE_SELECT';
export const INIT_SET_CENTER = 'INIT_SET_CENTER';
export const SET_CENTER = 'SET_CENTER';
export const ZOOM_CHANGED = 'ZOOM_CHANGED';
export const RADIUS_CHANGED = 'RADIUS_CHANGED';
export const SET_GOOGLE = 'SET_GOOGLE';

// Layers
export const INIT_GRONDVOG = 'INIT_GRONDVOG';
export const GET_GRONDVOG = 'GET_GRONDVOG';
export const SET_GRONDVOG = 'SET_GRONDVOG';
export const GET_GRONDVOG_FAILED = 'GET_GRONDVOG_FAILED';

export const LAYERSETTINGS_TOGGLE = 'LAYERSETTINGS_TOGGLE';

export const INIT_LAYERSLYS = 'INIT_LAYERSLYS';
export const GET_LAYERSLYS = 'GET_LAYERSLYS';
export const SET_LAYERSLYS = 'SET_LAYERSLYS';
export const GET_LAYERSLYS_FAILED = 'GET_LAYERSLYS_FAILED';

export const KIES_LAYER = 'KIES_LAYER';

export const INIT_LAYERSAKTIEF = 'INIT_LAYERSAKTIEF';
export const GET_LAYERSAKTIEF = 'GET_LAYERSAKTIEF';
export const SET_LAYERSAKTIEF = 'SET_LAYERSAKTIEF';
export const GET_LAYERSAKTIEF_FAILED = 'GET_LAYERSAKTIEF_FAILED';
export const REMOVE_LAYER = 'REMOVE_LAYER';

export const CHANGE_LAYERTIPE = 'CHANGE_LAYERTIPE';
export const CHANGE_LAYERFILTER = 'CHANGE_LAYERFILTER';

export const SET_LAYER_EVENTLISTENER = 'SET_LAYER_EVENTLISTENER';

export const BIND_EVENTLISTENER = 'BIND_EVENTLISTENER';
export const BIND_COMPONENT = 'BIND_COMPONENT';

// Layers - verkenning
export const LAYERSETTINGS_TOGGLE_VERKENNING = 'LAYERSETTINGS_TOGGLE_VERKENNING';

export const INIT_LAYERSLYS_VERKENNING = 'INIT_LAYERSLYS_VERKENNING';
export const GET_LAYERSLYS_VERKENNING = 'GET_LAYERSLYS_VERKENNING';
export const SET_LAYERSLYS_VERKENNING = 'SET_LAYERSLYS_VERKENNING';
export const GET_LAYERSLYS_FAILED_VERKENNING = 'GET_LAYERSLYS_FAILED_VERKENNING';

export const KIES_LAYER_VERKENNING = 'KIES_LAYER_VERKENNING';

export const INIT_LAYERSAKTIEF_VERKENNING = 'INIT_LAYERSAKTIEF_VERKENNING';
export const GET_LAYERSAKTIEF_VERKENNING = 'GET_LAYERSAKTIEF_VERKENNING';
export const SET_LAYERSAKTIEF_VERKENNING = 'SET_LAYERSAKTIEF_VERKENNING';
export const GET_LAYERSAKTIEF_FAILED_VERKENNING = 'GET_LAYERSAKTIEF_FAILED_VERKENNING';
export const REMOVE_LAYER_VERKENNING = 'REMOVE_LAYER_VERKENNING';

export const CHANGE_LAYERTIPE_VERKENNING = 'CHANGE_LAYERTIPE_VERKENNING';
export const CHANGE_LAYERFILTER_VERKENNING = 'CHANGE_LAYERFILTER_VERKENNING';

export const SET_LAYER_EVENTLISTENER_VERKENNING = 'SET_LAYER_EVENTLISTENER_VERKENNING';

export const BIND_EVENTLISTENER_VERKENNING = 'BIND_EVENTLISTENER_VERKENNING';
export const BIND_COMPONENT_VERKENNING = 'BIND_COMPONENT_VERKENNING';

// Layers - legacy
export const LAYERSETTINGS_TOGGLE_LEGACY = 'LAYERSETTINGS_TOGGLE_LEGACY';

export const INIT_LAYERSLYS_LEGACY = 'INIT_LAYERSLYS_LEGACY';
export const GET_LAYERSLYS_LEGACY = 'GET_LAYERSLYS_LEGACY';
export const SET_LAYERSLYS_LEGACY = 'SET_LAYERSLYS_LEGACY';
export const GET_LAYERSLYS_FAILED_LEGACY = 'GET_LAYERSLYS_FAILED_LEGACY';

export const KIES_LAYER_LEGACY = 'KIES_LAYER_LEGACYG';

export const INIT_LAYERSAKTIEF_LEGACY = 'INIT_LAYERSAKTIEF_LEGACY';
export const GET_LAYERSAKTIEF_LEGACY = 'GET_LAYERSAKTIEF_LEGACY';
export const SET_LAYERSAKTIEF_LEGACY = 'SET_LAYERSAKTIEF_LEGACY';
export const GET_LAYERSAKTIEF_FAILED_LEGACY = 'GET_LAYERSAKTIEF_FAILED_LEGACY';
export const REMOVE_LAYER_LEGACY = 'REMOVE_LAYER_LEGACY';

export const CHANGE_LAYERTIPE_LEGACY = 'CHANGE_LAYERTIPE_LEGACY';
export const CHANGE_LAYERFILTER_LEGACY = 'CHANGE_LAYERFILTER_LEGACY';

export const SET_LAYER_EVENTLISTENER_LEGACY = 'SET_LAYER_EVENTLISTENER_LEGACY';

export const BIND_EVENTLISTENER_LEGACY = 'BIND_EVENTLISTENER_LEGACYG';
export const BIND_COMPONENT_LEGACY = 'BIND_COMPONENT_LEGACY';


// Editmode
export const TOGGLE_SKEPMENUITEMS = 'TOGGLE_SKEPMENUITEMS';
export const TOGGLE_EDITMENUITEMS = 'TOGGLE_EDITMENUITEMS';
export const OPEN_OPSTELLINGSIDEDRAWER = 'OPEN_SKOPSTELLINGSIDEDRAWER';
export const CLOSE_OPSTELLINGSIDEDRAWER = 'CLOSE_SKOPSTELLINGSIDEDRAWER';
export const DUPLISEER_BLOK = 'DUPLISEER_BLOK';

// export const SET_GRENSEGETEKEN = 'SET_GRENSEGETEKEN';
export const SET_TEKENMODE = 'SET_TEKENMODE';

export const ADD_GRENS = 'ADD_GRENS';
export const CANCEL_ADD_GRENS = 'CANCEL_ADD_GRENS';
export const REMOVE_GRENS = 'REMOVE_GRENS';
export const CLEAR_GRENSE = 'CLEAR_GRENSE';

export const SET_EDITMODETYPE = 'SET_EDITMODETYPE';

// Take board en cards
export const INIT_TAKE_CARDS = 'INIT_TAKE_CARDS';
export const GET_TAKE_CARDS = 'GET_TAKE_CARDS';
export const SET_TAKE_CARDS = 'SET_TAKE_CARDS';
export const GET_TAKE_CARDS_FAILED = 'GET_TAKE_CARDS_FAILED';
export const SET_TAAK_STATUS = 'SET_TAAK_STATUS';
export const SET_TAAK_STATUS_FAILED = 'SET_TAAK_STATUS_FAILED';
export const CLEAR_TAAK_STATUS_FAILED = 'CLEAR_TAAK_STATUS_FAILED';
export const SET_TAAK_INDEX = 'SET_TAAK_INDEX';
export const SET_TAAK_INDEX_FAILED = 'SET_TAAK_INDEX_FAILED';
export const CLEAR_TAAK_INDEX_FAILED = 'CLEAR_TAAK_INDEX_FAILED';
export const SET_TAKE_FILTER = 'SET_TAKE_FILTER';
export const CLEAR_TAKE_FILTER = 'CLEAR_TAKE_FILTER';
export const OPEN_SKEP_INSTRUKSIE = 'OPEN_SKEP_INSTRUKSIE';
export const INIT_TAKE_CARDS_PER_LANE = 'INIT_TAKE_CARDS_PER_LANE';
export const GET_TAKE_CARDS_PER_LANE = 'GET_TAKE_CARDS_PER_LANE';
export const SET_TAKE_CARDS_PER_LANE_LOADING = 'SET_TAKE_CARDS_PER_LANE_LOADING';
export const SET_TAKE_CARDS_PER_LANE = 'SET_TAKE_CARDS_PER_LANE';
export const GET_TAKE_CARDS_PER_LANE_FAILED = 'GET_TAKE_CARDS_PER_LANE_FAILED';
export const SET_TAKE_CARDS_PER_LANE_LAZY_LOADING = 'SET_TAKE_CARDS_PER_LANE_LAZY_LOADING';
export const SET_TAKE_CARDS_PER_LANE_LAZY = 'SET_TAKE_CARDS_PER_LANE_LAZY';
export const SET_TAKE_CARDS_SKUIF = 'SET_TAKE_CARDS_SKUIF';

// Instruksies board en cards
export const SET_LOADING_INSTRUKSIES_CARDS = 'SET_LOADING_INSTRUKSIES_CARDS';
export const INIT_INSTRUKSIES_CARDS = 'INIT_INSTRUKSIES_CARDS';
export const GET_INSTRUKSIES_CARDS = 'GET_INSTRUKSIES_CARDS';
export const SET_INSTRUKSIES_CARDS = 'SET_INSTRUKSIES_CARDS';
export const GET_INSTRUKSIES_CARDS_FAILED = 'GET_INSTRUKSIES_CARDS_FAILED';
export const CLEAR_INSTRUKSIES_CARDS = 'CLEAR_INSTRUKSIES_CARDS';
export const OPEN_SIEN_INSTRUKSIE = 'OPEN_SIEN_INSTRUKSIE';
export const CLOSE_SIEN_INSTRUKSIE = 'CLOSE_SIEN_INSTRUKSIE';
export const KIES_INSTRUKSIE = 'KIES_INSTRUKSIE';
export const SELECT_INSTRUKSIE = 'SELECT_INSTRUKSIE';
export const INSTR_SET_DATUMS_GEKRY = 'INSTR_SET_DATUMS_GEKRY';

export const SET_INSTRUKSIES_FILTER = 'SET_INSTRUKSIES_FILTER';
export const CLEAR_INSTRUKSIES_FILTER = 'CLEAR_INSTRUKSIES_FILTER';
export const SEARCH_INSTRUKSIES = 'SEARCH_INSTRUKSIES';

export const INSTR_SET_VIEW = 'INSTR_SET_VIEW';
export const INSTR_ADD_DATUM = 'INSTR_ADD_DATUM';
export const INSTR_SUBTRACT_DATUM = 'INSTR_SUBTRACT_DATUM';
export const INSTR_SET_VANDAG = 'INSTR_SET_VANDAG';
export const INSTR_SET_DATUM = 'INSTR_SET_DATUM';

export const INSTR_INVUL_STEL_DATUMS = "INSTR_INVUL_STEL_DATUMS";
export const INSTR_INVUL_STEL_DATUMS_TYE = "INSTR_INVUL_STEL_DATUMS_TYE";
export const INSTR_INVUL_REMOVE_REKORD = "INSTR_INVUL_REMOVE_REKORD";
export const INSTR_INVUL_REMOVE_NESTED_REKORD = "INSTR_INVUL_REMOVE_NESTED_REKORD";
export const INSTR_INVUL_STEL_REKORD_TYD = "INSTR_INVUL_STEL_REKORD_TYD";
export const INSTR_INVUL_STEL_NESTED_REKORD_TYD = "INSTR_INVUL_STEL_NESTED_REKORD_TYD";
export const INSTR_INVUL_DATA_OPEN = "INSTR_INVUL_DATA_OPEN";
export const INSTR_INVUL_DATA_CLOSE = "INSTR_INVUL_DATA_CLOSE";
export const INSTR_INVUL_DATA_MODAL_CONTENT = "INSTR_INVUL_DATA_MODAL_CONTENT";
export const INSTR_INVUL_ADD_ARBEIDERS = "INSTR_INVUL_ADD_ARBEIDERS";
export const INSTR_INVUL_ADD_ITEMTIPES = "INSTR_INVUL_ADD_ITEMTIPES";
export const INSTR_INVUL_ADD_ITEMS = "INSTR_INVUL_ADD_ITEMS";
export const INSTR_INVUL_ADD_VERBRUIKSITEMS = "INSTR_INVUL_ADD_VERBRUIKSITEMS";
export const INSTR_INVUL_SET_ITEM_ID_SELECTED = "INSTR_INVUL_SET_ITEM_ID_SELECTED";

export const INSTR_INVUL_SET_LOADING_INSTRUKSIE = 'INSTR_INVUL_SET_LOADING_INSTRUKSIE';
export const INSTR_INVUL_INIT_INSTRUKSIE = 'INSTR_INVUL_INIT_INSTRUKSIE';
export const INSTR_INVUL_GET_INSTRUKSIE = 'INSTR_INVUL_GET_INSTRUKSIE';
export const INSTR_INVUL_SET_INSTRUKSIE = 'INSTR_INVUL_SET_INSTRUKSIE';
export const INSTR_INVUL_GET_INSTRUKSIE_FAILED = 'INSTR_INVUL_GET_INSTRUKSIE_FAILED';
export const INSTR_INVUL_SET_LOADING_INSTRUKSIE_INGEVUL = 'INSTR_INVUL_SET_LOADING_INSTRUKSIE_INGEVUL';
export const INSTR_INVUL_INIT_INSTRUKSIE_INGEVUL = 'INSTR_INVUL_INIT_INSTRUKSIE_INGEVUL';
export const INSTR_INVUL_GET_INSTRUKSIE_INGEVUL = 'INSTR_INVUL_GET_INSTRUKSIE_INGEVUL';
export const INSTR_INVUL_SET_INSTRUKSIE_INGEVUL = 'INSTR_INVUL_SET_INSTRUKSIE_INGEVUL';
export const INSTR_INVUL_GET_INSTRUKSIE_INGEVUL_FAILED = 'INSTR_INVUL_GET_INSTRUKSIE_INGEVUL_FAILED';
export const INSTR_INVUL_CHANGE_CUSTOMFIELD_VALUE = 'INSTR_INVUL_CHANGE_CUSTOMFIELD_VALUE';

// Notifications
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_NOTIFICATIONS_FAILED = 'GET_NOTIFICATIONS_FAILED';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

// Custom layers
export const LAYERLEFTSIDEBAR_TOGGLE = 'LAYERLEFTSIDEBAR_TOGGLE';
export const SKEP_TEMP_CUSTOM_LAYER = 'SKEP_TEMP_CUSTOM_LAYER';
export const EDIT_TEMP_CUSTOM_LAYER = 'EDIT_TEMP_CUSTOM_LAYER';
export const EDIT_TEMP_CUSTOM_LAYER_ERROR = 'EDIT_TEMP_CUSTOM_LAYER_ERROR';
export const EDIT_TEMP_CUSTOM_LAYER_VALIDATE = 'EDIT_TEMP_CUSTOM_LAYER_VALIDATE';
export const INIT_LAYERSLYS_CUSTOM = 'INIT_LAYERSLYS_CUSTOM';
export const GET_LAYERSLYS_CUSTOM = 'GET_LAYERSLYS_CUSTOM';
export const SET_LAYERSLYS_CUSTOM = 'SET_LAYERSLYS_CUSTOM';
export const GET_LAYERSLYS_FAILED_CUSTOM = 'GET_LAYERSLYS_FAILED_CUSTOM';
export const KIES_LAYER_CUSTOM = 'KIES_LAYER_CUSTOM';
export const INIT_LAYERSAKTIEF_CUSTOM = 'INIT_LAYERSAKTIEF_CUSTOM';
export const GET_LAYERSAKTIEF_CUSTOM = 'GET_LAYERSAKTIEF_CUSTOM';
export const SET_LAYERSAKTIEF_CUSTOM = 'SET_LAYERSAKTIEF_CUSTOM';
export const GET_LAYERSAKTIEF_FAILED_CUSTOM = 'GET_LAYERSAKTIEF_FAILED_CUSTOM';
export const REMOVE_LAYER_CUSTOM = 'REMOVE_LAYER_CUSTOM';
export const SET_LAYER_EVENTLISTENER_CUSTOM = 'SET_LAYER_EVENTLISTENER_CUSTOM';
export const BIND_EVENTLISTENER_CUSTOM = 'BIND_EVENTLISTENER_CUSTOM';
export const BIND_COMPONENT_CUSTOM = 'BIND_COMPONENT_CUSTOM';
export const TOGGLE_FEATURE_INFOBOX = 'TOGGLE_FEATURE_INFOBOX';
export const VERWYDER_FEATURE = 'VERWYDER_FEATURE';
export const SKEP_CUSTOM_LAYER = 'SKEP_CUSTOM_LAYER';
export const STOOR_CUSTOM_LAYER = 'STOOR_CUSTOM_LAYER';
export const STOOR_CUSTOM_LAYER_LOADING = 'STOOR_CUSTOM_LAYER_LOADING';
export const STOOR_CUSTOM_LAYER_FAILED = 'STOOR_CUSTOM_LAYER_FAILED';
export const STOOR_CUSTOM_LAYER_SUCCESS = 'STOOR_CUSTOM_LAYER_SUCCESS';
export const STOOR_NUWE_CUSTOM_LAYER_SUCCESS = 'STOOR_NUWE_CUSTOM_LAYER_SUCCESS';
export const EDIT_FEATURE_PROPERTY = 'EDIT_FEATURE_PROPERTY';
export const LAYER_TOGGLE_CUSTOM = 'LAYER_TOGGLE_CUSTOM';
export const KIES_LAYER_VERSION_CUSTOM = 'KIES_LAYER_VERSION_CUSTOM';
export const REMOVE_LAYER_VERSOIN_CUSTOM = 'REMOVE_LAYER_VERSOIN_CUSTOM';
export const SET_LAYERSAKTIEF_VERSION_CUSTOM = 'SET_LAYERSAKTIEF_VERSION_CUSTOM';
export const MAKE_LAYER_EDITABLE_CUSTOM = 'MAKE_LAYER_EDITABLE_CUSTOM';
export const SET_MAKE_LAYER_EDITABLE_CUSTOM = 'SET_MAKE_LAYER_EDITABLE_CUSTOM';
export const SKEP_TEMP_CUSTOM_LAYER_INIT = 'SKEP_TEMP_CUSTOM_LAYER_INIT';
export const EDIT_TEMP_CUSTOM_LAYER_KANSELLEER = 'EDIT_TEMP_CUSTOM_LAYER_KANSELLEER';
export const ON_CUSTOM_LAYER_STOOR = 'ON_CUSTOM_LAYER_STOOR';
export const ON_CUSTOM_LAYER_STOOR_LOADING = 'ON_CUSTOM_LAYER_STOOR_LOADING';
export const ON_CUSTOM_LAYER_STOOR_SUCCESS = 'ON_CUSTOM_LAYER_STOOR_SUCCESS';
export const ON_CUSTOM_LAYER_STOOR_FAILED = 'ON_CUSTOM_LAYER_STOOR_FAILED';
export const STOOR_CUSTOM_LAYER_CLEARNOTIFICATION = 'STOOR_CUSTOM_LAYER_CLEARNOTIFICATION';
export const SKEP_CUSTOM_LAYER_LOADING = 'SKEP_CUSTOM_LAYER_LOADING';
export const SKEP_CUSTOM_LAYER_SUCCESS = 'SKEP_CUSTOM_LAYER_SUCCESS';
export const SKEP_CUSTOM_LAYER_FAILED = 'SKEP_CUSTOM_LAYER_FAILED';
export const SKEP_CUSTOM_LAYER_CLEARNOTIFICATION = 'SKEP_CUSTOM_LAYER_CLEARNOTIFICATION';
export const SKEP_CUSTOM_LAYER_TELLING = 'SKEP_CUSTOM_LAYER_TELLING';
export const SKEP_CUSTOM_LAYER_CLOSE = 'SKEP_CUSTOM_LAYER_CLOSE';
export const STOOR_CUSTOM_LAYER_SUCCESS_MESSAGE = 'STOOR_CUSTOM_LAYER_SUCCESS_MESSAGE';
export const SHOW_FEATURE_INFOBOX = 'SHOW_FEATURE_INFOBOX';
export const CLOSE_FEATURE_INFOBOX = 'CLOSE_FEATURE_INFOBOX';
export const DELETE_CUSTOM_LAYER_VERSION = 'DELETE_CUSTOM_LAYER_VERSION';
export const DELETE_CUSTOM_LAYER_VERSION_LOADING = 'DELETE_CUSTOM_LAYER_VERSION_LOADING';
export const DELETE_CUSTOM_LAYER_VERSION_SUCCESS_MESSAGE = 'DELETE_CUSTOM_LAYER_VERSION_SUCCESS_MESSAGE';
export const DELETE_CUSTOM_LAYER_VERSION_SUCCESS = 'DELETE_CUSTOM_LAYER_VERSION_SUCCESS';
export const DELETE_CUSTOM_LAYER_VERSION_FAILED = 'DELETE_CUSTOM_LAYER_VERSION_FAILED';
export const CHANGE_LAYER_NAME = 'CHANGE_LAYER_NAME';
export const CHANGE_LAYER_NAME_LOADING = 'CHANGE_LAYER_NAME_LOADING';
export const CHANGE_LAYER_NAME_SUCCESS_MESSAGE = 'CHANGE_LAYER_NAME_SUCCESS_MESSAGE';
export const CHANGE_LAYER_NAME_SUCCESS = 'CHANGE_LAYER_NAME_SUCCESS';
export const CHANGE_LAYER_NAME_FAILED = 'CHANGE_LAYER_NAME_FAILED';
export const SET_CHANGE_LAYER_NAME = 'SET_CHANGE_LAYER_NAME';
export const ADD_CUSTOM_LAYER_LOG = 'ADD_CUSTOM_LAYER_LOG';
export const CLEAR_CUSTOM_LAYER_LOGS = 'CLEAR_CUSTOM_LAYER_LOGS';
export const GET_ICONS_CL = 'GET_ICONS_CL';
export const SET_ICONS_CL = 'SET_ICONS_CL';
export const GET_ICONS_FAILED_CL = 'GET_ICONS_FAILED_CL';
export const SEARCH_ICONS_CL = 'SEARCH_ICONS_CL';
export const ADD_FEATURES_PROGR_CUSTOM_LAYER = 'ADD_FEATURES_PROGR_CUSTOM_LAYER';
export const SET_DRAWINGMODE_CUSTOM_LAYER = 'SET_DRAWINGMODE_CUSTOM_LAYER';
export const SAVE_TEMPLAATICON_CUSTOM_LAYER = 'SAVE_TEMPLAATICON_CUSTOM_LAYER';
export const GEBRUIK_TEMPLAATICON_CUSTOM_LAYER = 'GEBRUIK_TEMPLAATICON_CUSTOM_LAYER';
export const KIES_TEMPLAATICON_CUSTOM_LAYER = 'KIES_TEMPLAATICON_CUSTOM_LAYER';
export const STEL_KOORDINATE_CUSTOM_LAYER = 'STEL_KOORDINATE_CUSTOM_LAYER';

// Plukbeplanner

export const PLUKBEPL_ADD_DATUM = 'PLUKBEPL_ADD_DATUM';
export const PLUKBEPL_SUBTRACT_DATUM = 'PLUKBEPL_SUBTRACT_DATUM';
export const PLUKBEPL_SET_VANDAG = 'PLUKBEPL_SET_VANDAG';
export const PLUKBEPL_SET_DATUM = 'PLUKBEPL_SET_DATUM';
export const PLUKBEPL_SET_WEEK_BEGIN = 'PLUKBEPL_SET_WEEK_BEGIN';
export const GET_PLUKBEPL_KULTIVARS = 'GET_PLUKBEPL_KULTIVARS';
export const SET_PLUKBEPL_KULTIVARS = 'SET_PLUKBEPL_KULTIVARS';
export const SET_PLUKBEPL_KULTIVARS_FAILED = 'SET_PLUKBEPL_KULTIVARS_FAILED';
export const GET_PLUKBEPL_WEEK = 'GET_PLUKBEPL_WEEK';
export const SET_PLUKBEPL_WEEK = 'SET_PLUKBEPL_WEEK';
export const SET_PLUKBEPL_WEEK_FAILED = 'SET_PLUKBEPL_WEEK_FAILED';
export const GET_PLUKBEPL_WEEKDAE = 'GET_PLUKBEPL_WEEKDAE';
export const SET_PLUKBEPL_WEEKDAE = 'SET_PLUKBEPL_WEEKDAE';
export const SET_PLUKBEPL_WEEKDAE_FAILED = 'SET_PLUKBEPL_WEEKDAE_FAILED';
export const GET_PLUKBEPL_OPSTELLINGS = 'GET_PLUKBEPL_OPSTELLINGS';
export const SET_PLUKBEPL_OPSTELLINGS = 'SET_PLUKBEPL_OPSTELLINGS';
export const SET_PLUKBEPL_OPSTELLINGS_FAILED = 'SET_PLUKBEPL_OPSTELLINGS_FAILED';
export const SET_PLUKBEPL_OPSTELLINGS_SNACKBAR_SUCCESS = 'SET_PLUKBEPL_OPSTELLINGS_SNACKBAR_SUCCESS';
export const SET_PLUKBEPL_OPSTELLINGS_SNACKBAR_FAILED = 'SET_PLUKBEPL_OPSTELLINGS_SNACKBAR_FAILED';
export const SET_PLUKBEPL_SNACKBAR_CLOSE = 'SET_PLUKBEPL_SNACKBAR_CLOSE';
export const PLUKBEPL_SET_VIEWEENHEID = 'PLUKBEPL_SET_VIEWEENHEID';
export const PLUKBEPL_GET_WEEKTEIKEN = 'PLUKBEPL_GET_WEEKTEIKEN';
export const PLUKBEPL_SET_WEEKTEIKEN = 'PLUKBEPL_SET_WEEKTEIKEN';
export const PLUKBEPL_GET_DAGTEIKEN = 'PLUKBEPL_GET_DAGTEIKEN';
export const PLUKBEPL_SET_DAGTEIKEN = 'PLUKBEPL_SET_DAGTEIKEN';
export const PLUKBEPL_GET_DAGITEM = 'PLUKBEPL_GET_DAGITEM';
export const PLUKBEPL_SET_DAGITEM = 'PLUKBEPL_SET_DAGITEM';
export const PLUKBEPL_SET_GEWASFILTER = 'PLUKBEPL_SET_GEWASFILTER';